import { render } from "./PublicProposal.vue?vue&type=template&id=79f1f646"
import script from "./PublicProposal.vue?vue&type=script&lang=js"
export * from "./PublicProposal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/proposal/PublicProposal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "79f1f646"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('79f1f646', __exports__)) {
    api.reload('79f1f646', __exports__)
  }
  
  module.hot.accept("./PublicProposal.vue?vue&type=template&id=79f1f646", () => {
    api.rerender('79f1f646', render)
  })

}


export default __exports__